var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPackageInCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    opacity: 0.3,
    d: "M32.01,9.164A1.667,1.667,0,0,1,33,10.687v14.6a1.667,1.667,0,0,1-.857,1.457L18.809,34.154a1.666,1.666,0,0,1-1.619,0L3.857,26.747A1.667,1.667,0,0,1,3,25.29v-14.6a1.667,1.667,0,0,1,.99-1.523L17.323,3.238a1.666,1.666,0,0,1,1.354,0Z",
    transform: "translate(2 2.063)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.879,4.224,7.6,11.046v7.647l3.333,1.667V13.007L23.692,5.919Z",
    transform: "translate(5.067 2.816)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageInCircle);
export default __webpack_public_path__ + "static/media/package_in_circle.27c2c153e717393fda9b6bd4310ea755.svg";
export { ForwardRef as ReactComponent };